import { CaretDownIcon, CheckIcon } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import {
  Menu,
  MenuItem,
  MenuPopover,
  MenuSeparator,
  MenuTrigger,
} from "@/components/ui/menu";
import { cn } from "@/lib/utils";

const menuItemClass =
  "flex h-auto min-h-0 cursor-pointer flex-col items-stretch gap-1 rounded py-2.5 pl-2.5 pr-2 text-left data-focused:bg-slate-300/10";

export interface BriefingModeMenuProps {
  mode: "briefing" | "deep";
  onModeChange: (mode: "briefing" | "deep") => void;
  isDisabled?: boolean;
}

export const BriefingModeMenu = ({
  mode,
  onModeChange,
  isDisabled,
}: BriefingModeMenuProps) => {
  const triggerLabel = mode === "deep" ? "Herald Thinking" : "Herald";

  return (
    <MenuTrigger>
      <Button
        variant="ghost"
        isDisabled={isDisabled}
        className="flex items-center gap-2 h-8 px-2 mr-1"
      >
        <span className="tracking-wide font-normal">{triggerLabel}</span>
        <CaretDownIcon className="size-4 shrink-0 text-gray-600" aria-hidden />
      </Button>
      <MenuPopover
        placement="bottom end"
        offset={6}
        className="w-[260px] min-w-[260px] border border-gray-200 bg-white p-0 shadow-xl"
      >
        <Menu className="max-h-none bg-transparent p-1.5">
          <MenuItem
            textValue="Herald"
            onAction={() => onModeChange("briefing")}
            className={menuItemClass}
          >
            <div className="flex w-full items-start justify-between gap-2">
              <span className="text-sm text-gray-900">Herald</span>
              {mode === "briefing" ? (
                <CheckIcon
                  className="size-4 shrink-0 text-gray-900"
                  aria-hidden
                />
              ) : (
                <span className="size-4 shrink-0" aria-hidden />
              )}
            </div>
            <p className="text-left text-xxs leading-4 tracking-wide text-gray-600">
              Fast, clear answers about what&apos;s happening now
            </p>
          </MenuItem>
          <MenuSeparator />
          <MenuItem
            textValue="Herald Thinking"
            onAction={() => onModeChange("deep")}
            className={menuItemClass}
          >
            <div className="flex w-full items-start justify-between gap-2">
              <span
                className={cn(
                  "text-sm",
                  mode === "deep" ? "text-gray-900" : "text-gray-700",
                )}
              >
                Herald Thinking
              </span>
              {mode === "deep" ? (
                <CheckIcon
                  className="size-4 shrink-0 text-gray-900"
                  aria-hidden
                />
              ) : (
                <span className="size-4 shrink-0" aria-hidden />
              )}
            </div>
            <p className="text-left text-xxs leading-4 tracking-wide text-gray-600">
              Strategic analysis with clear recommendations
            </p>
          </MenuItem>
        </Menu>
      </MenuPopover>
    </MenuTrigger>
  );
};
